import { RetailerRejectionReason } from '../../indigofair/data/RetailerRejectionReason';

export namespace ISelfServeContextIdvResponse {
  export enum IdvStatus {
    IDV_STATUS_UNKNOWN = 'IDV_STATUS_UNKNOWN',
    CONFIRMED = 'CONFIRMED',
    REJECTED = 'REJECTED',
    NMI_SUBMITTED = 'NMI_SUBMITTED',
    NMI_REQUESTED = 'NMI_REQUESTED',
    IDV_SUBMITTED = 'IDV_SUBMITTED',
    IDV_REQUESTED = 'IDV_REQUESTED',
    UNVERIFIED_WITH_ORDERS_WAITING_IN_REVIEW_QUEUE = 'UNVERIFIED_WITH_ORDERS_WAITING_IN_REVIEW_QUEUE',
    UNVERIFIED_WITH_NO_ORDERS_WAITING_ON_REVIEW = 'UNVERIFIED_WITH_NO_ORDERS_WAITING_ON_REVIEW',
  }

  /**
   * Return an instance of ISelfServeContextIdvResponse with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<ISelfServeContextIdvResponse>
  ): ISelfServeContextIdvResponse =>
    ({
      ...(partial ?? {}),
    }) as ISelfServeContextIdvResponse;
}

export interface ISelfServeContextIdvResponse {
  retailer_token: string | undefined;
  idv_status: keyof typeof ISelfServeContextIdvResponse.IdvStatus | undefined;
  rejection_reason: keyof typeof RetailerRejectionReason | undefined;
}
